import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ForgotPasswordComponent } from "@app/auth/components/forgot-password/forgot-password.component";
import { LoginInterstitialComponent } from "@app/auth/components/login-interstitial.component/login-interstitial.component";
import { LoginPageComponent } from "@app/auth/components/login-page/login-page.component";
import { MobilePasswordResetLandingPageComponent } from "./components/mobile-password-reset-landing-page/mobile-password-reset-landing-page.component";
import { ResetPasswordSentComponent } from "./components/reset-password-sent/reset-password-sent.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { AuthGuard } from "./services/authguard.service";

export const routes: Routes = [
    { path: "", component: LoginPageComponent },
    { path: "forgot-password", component: ForgotPasswordComponent },
    { path: "mobile-forgot-password", component: MobilePasswordResetLandingPageComponent },
    { path: "update-login", component: ForgotPasswordComponent },
    { path: "reset-password", component: ResetPasswordComponent },
    { path: "social/:type", component: LoginInterstitialComponent },
    {
        path: "reset-password-sent",
        component: ResetPasswordSentComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [AuthGuard],
})
export class AuthRoutingModule {}
